import { styled } from '../../../stitches.config';
import { RootCategory } from '@/components/BudgetCalculator/RootCategoryForm';
import { getRootCategorySankeyInfo } from '@/components/BudgetCalculator/util';
import Typography from '@/components/sushi/Typography';
import { FormattedMessage } from 'react-intl';
import NumberFormat from '@/components/common/NumberFormat';
import * as React from 'react';

export const CalculatorRecap = ({
  income,
  investments,
  expenses,
}: {
  income: RootCategory;
  investments: RootCategory;
  expenses: RootCategory;
}) => {
  const { categoryTotalValue: incomeTotal } = getRootCategorySankeyInfo(income);
  const { categoryTotalValue: investmentsTotal } = getRootCategorySankeyInfo(investments);
  const { categoryTotalValue: expensesTotal } = getRootCategorySankeyInfo(expenses);
  const possibleSavingsRate = (incomeTotal - expensesTotal) / incomeTotal;
  const currentSavingsRate = investmentsTotal / incomeTotal;
  const remainingTotal = incomeTotal - expensesTotal - investmentsTotal;

  return (
    <Recap>
      <Typography variant={'bodyM'} color={'tag'}>
        <FormattedMessage
          id={'budget_calculator.summary'}
          values={{
            current_saving_rate: (
              <Typography as={'span'} variant={'bodyM'} weight={'medium'} color={'tag'}>
                <NumberFormat value={currentSavingsRate * 100} type="percent" />
              </Typography>
            ),
            possible_saving_rate:
              currentSavingsRate.toFixed(2) !== possibleSavingsRate.toFixed(2) ? (
                <FormattedMessage
                  id={'budget_calculator.possible_saving_rate'}
                  values={{
                    possible_saving_rate: (
                      <Typography as={'span'} variant={'bodyM'} weight={'medium'} color={'tag'}>
                        <NumberFormat value={possibleSavingsRate * 100} type="percent" />
                      </Typography>
                    ),
                  }}
                />
              ) : null,
            income_total: (
              <Typography as={'span'} variant={'bodyM'} weight={'medium'} color={'tag'}>
                <NumberFormat value={incomeTotal} type="currency" currency="EUR" />
              </Typography>
            ),
            expenses_total: (
              <Typography as={'span'} variant={'bodyM'} weight={'medium'} color={'tag'}>
                <NumberFormat value={expensesTotal} type="currency" currency="EUR" />
              </Typography>
            ),
            investments_total: (
              <Typography as={'span'} variant={'bodyM'} weight={'medium'} color={'tag'}>
                <NumberFormat value={investmentsTotal} type="currency" currency="EUR" />
              </Typography>
            ),
            remaining_total:
              remainingTotal !== 0 ? (
                <FormattedMessage
                  id={
                    remainingTotal > 0
                      ? 'budget_calculator.remaining_total'
                      : 'budget_calculator.remaining_total_over_budget'
                  }
                  values={{
                    remaining_total: (
                      <Typography as={'span'} variant={'bodyM'} weight={'medium'} color={'tag'}>
                        <NumberFormat value={remainingTotal} type="currency" currency="EUR" />
                      </Typography>
                    ),
                  }}
                />
              ) : null,
          }}
        />
      </Typography>
    </Recap>
  );
};
const Recap = styled('div', { width: '100%', maxWidth: 800, margin: '48px auto 0' });
